<information outer-style="width:100%; margin-top:1em">
          <h3 translate>
               {{'setup_2.additional_doc.header'}}
          </h3>
          <div class="padding-top-1em" translate>
               {{ "setup_2.additional_doc.text1" }}
          </div>
          <div class="padding-top-1em" translate>
               {{ "setup_2.additional_doc.text2" }}
          </div>
          <div class="padding-top-1em" translate [innerHTML]="'setup_2.additional_doc.step1_header' | translate"></div>
          <div class="pad-left">
               {{ "setup_2.additional_doc.step1_text1" | translate }}
               <a routerLink="/{{ orgContactPath }}" href="#" title="{{'setup_2.org_contact_title' | translate}}">{{
                    "setup_2.additional_doc.step1_text2" | translate
                    }}</a>
               {{ "setup_2.additional_doc.step1_text3" | translate }}
          </div>

          <div class="padding-top-1em" translate [innerHTML]="'setup_2.additional_doc.step2_header' | translate"></div>
          <div translate class="pad-left">
               {{ "setup_2.additional_doc.step2_text1" }}
          </div>

          <div class="padding-top-1em" translate [innerHTML]="'setup_2.additional_doc.step3_header' | translate"></div>
          <div translate class="pad-left">
               {{ "setup_2.additional_doc.step3_text1" }}
          </div>

          <div class="padding-top-1em" translate [innerHTML]="'setup_2.additional_doc.step4_header' | translate"></div>
          <div translate [innerHTML]="'setup_2.additional_doc.step4_text1' | translate" class="pad-left"></div>

          <div class="padding-top-1em" translate [innerHTML]="'setup_2.header_note' | translate">
          </div>
          <div translate [innerHTML]="'setup_2.additional_doc.note_text' | translate">
          </div>
</information>